import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import React, { useEffect } from 'react';
import { ModuleDto } from '../../../../swagger';
import useSecurityModules from '../../hooks/useSecurityModules';

const SecurityModule = ({ setSecurityModule, setSecurityRole }: any) => {
    const { data: modules } = useSecurityModules();
    const [data, setData] = React.useState<any>(modules?.slice());

    const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data: ModuleDto[] = modules!.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        setData(filterData(event.filter));
    };
    useEffect(() => {
        setData(modules);
    }, [modules]);

    return (
        <div style={{ margin: '0 0 1% 2vw' }}>
            <DropDownList
                data={data}
                filterable={true}
                textField="moduleName"
                dataItemKey="moduleId"
                label={'Module'}
                id={'security_module'}
                onChange={(e: DropDownListChangeEvent) => {
                    setSecurityModule(e.value);
                    setSecurityRole(undefined);
                }}
                onFilterChange={filterChange}
                style={{ width: '14%' }}
            />
        </div>
    );
};

export default SecurityModule;
